import React, { useState, useEffect } from "react";
import { fetchBingoConfig } from "../../api/cms";
import PageMeta from "../../components/PageMeta";
import AnalyticsPageLoad from "../../components/AnalyticsPageLoad";
import Bingo from "../../components/Bingo";
import GoogleAd from '../../components/GoogleAd';
import { BingoConfigProps, BannerAdType } from "../../types";


import "../../components/Bingo/scss/main.scss";
import BannerAd from "../../components/BannerAd";
import SingleVideo from "../../components/SingleVideo";

const BingoPage: React.FC<any> = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loadingError, setLoadingError] = useState(false);
  const [ad, setBannerAd] = useState<BannerAdType>();
  const [video, setVideo] = useState<string>();
  const [title, setTitle] = useState<string>();
  const [order, setOrder] = useState<string[]>([]);
  const [bingo, setBingo] = useState<BingoConfigProps>({});
  const [sitePageTitle, setPageTitle] =useState("Wheel Bingo");
  const [basicMetaTags, setBasicMetaTags] = useState<any>({});
  const [ogMetaTags, setOgMetaTags] = useState<any>({});
  const [twitterMetaTags, setTwitterMetaTags] = useState<any>({});
  const [googleAd, setGoogleAd] = useState<any>({});
  const [customAd, setCustomAd] = useState<any>({});

  useEffect(() => {
    fetchBingoConfig();

    const fetchData = async () => {
      setIsLoading(true);

      const data = await fetchBingoConfig();

      setIsLoading(false);

      if (data.error === true) {
        setLoadingError(true);
        return;
      }
      const {
        intro_logo,
        play_now_text,
        play_now_color,
        bg_image,
        game_logo,
        how_to_play_text,
        how_to_play_color,
        vol_on,
        vol_off,
        bingo_graphic,
        refresh_text,
        refresh_color,
        gameboard_bg,
        gameboard_br,
        winner_line,
        tile_hl_color,

        banner_ad_img,
        banner_ad_link,
        video_url,
        bingo_page_order,
        title,
        page_title,
        basic_meta_tags,
        og_meta_tags,
        twitter_meta_tags,
        google_ad,
        custom_ad,
      } = data;

      setBingo({
        introLogo: intro_logo,
        iconVolOn: vol_on,
        iconVolOff: vol_off,
        headerLogo: game_logo,
        backgroundImage: bg_image,
        winGraphic: bingo_graphic,

        boardBackgroundColor: gameboard_bg,
        boardBorderColor: gameboard_br,

        winLine: winner_line,

        tileHighlightColor: tile_hl_color,

        playBtnText: play_now_text,
        playBtnColor: play_now_color,
        refreshBtnText: refresh_text,
        refreshBtnColor: refresh_color,
        howToPlayBtnText: how_to_play_text,
        howToPlayBtnColor: how_to_play_color,
      });

      setBannerAd({ image: banner_ad_img, url: banner_ad_link });
      setVideo(video_url);
      setIsLoaded(true);
      setTitle(title);
      setOrder(bingo_page_order);


      if (page_title && page_title !== "" && page_title !== undefined) {
        setPageTitle(page_title);
      }
      if (basic_meta_tags && basic_meta_tags !== "" && basic_meta_tags !== undefined) {
        setBasicMetaTags(basic_meta_tags);
      }
      if (og_meta_tags && og_meta_tags !== "" && og_meta_tags !== undefined) {
        setOgMetaTags(og_meta_tags);
      }

      if (twitter_meta_tags && twitter_meta_tags !== "" && twitter_meta_tags !== undefined) {
        setTwitterMetaTags(twitter_meta_tags);
      }

      if (google_ad && google_ad !== "" && google_ad !== undefined) {
        setGoogleAd(google_ad);
      }

      if (custom_ad && custom_ad !== "" && custom_ad !== undefined) {
        setCustomAd(custom_ad);
      }
    };

    fetchData();
  }, []);

  const renderByOrder = () => {
    return (
      order &&
      order.map((c: string, i) => {
        switch (c) {
          case "Video":
            return (
              video && <SingleVideo key={i} url={video} id="bingo" image="" />
            );
          case "Banner ad":
            return (
              ad &&
              ad.image && <BannerAd key={i} image={ad.image} url={ad.url} />
            );
          case "Game":
            return <Bingo key={i} {...bingo} />;
          case "Google Ad":
            return (googleAd && googleAd !== undefined && Object.keys(googleAd).length > 0 ? <GoogleAd ad={googleAd} header={googleAd.headerScript} body={googleAd.bodyScript} /> : null);
          case "Custom Ad":
            return (customAd && customAd !== undefined && Object.keys(customAd).length > 0 ? <BannerAd image={customAd.ad_image} url={customAd.ad_link} /> : null);
          default:
            return null;
        }
      })
    );
  };

  return (
    <div className="wof-react-component bingo-wrapper">
      <PageMeta
        sitePageTitle={sitePageTitle}
        ogMetaTags={ogMetaTags}
        basicMetaTags={basicMetaTags} 
        twitterMetaTags={twitterMetaTags}
      />
      {isLoaded && <AnalyticsPageLoad contentTitle="Wheel Bingo" />}
      {renderByOrder()}
    </div>
  );
};

BingoPage.defaultProps = {
  banner_ad_link: "/node/1",
  video_url:
    "/sites/default/files/2020-04/y2mate.com%20-%20Contestants%20Try%20to%20Solve%20Blackberry%20Jam%20_%20Wheel%20of%20Fortune_AdIJ1UgNSLs_240p_1.mp4",
  bingo_page_order: ["Banner ad", "Video", "Game", "Google Ad", "Custom Ad"],
};

export default BingoPage;
